import { set } from 'lodash';
import { useCallback } from 'react';

import { CATEGORIES } from '@hivebrite/design-system/FontAwesomeIcon';
import { Tooltip } from '@hivebrite/design-system/Tooltip';

import ToolbarButton from 'hb-builder/components/common/Wrapper/components/ToolbarButton';
import {
  useBuilderContext,
  useComponentContext,
  usePanelContext,
} from 'hb-builder/hooks';

const ToolbarDelete = ({ tooltipPlace }) => {
  const { getParentPath, removeItem, updateItem } = useBuilderContext();
  const { setSelectedPanelTab } = usePanelContext();
  const { type, item } = useComponentContext();

  const handleDeleteItem = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      removeItem(item.id);
      setSelectedPanelTab('components');

      if (type === 'column' && item?.attributes?.width) {
        updateItem({
          path: getParentPath(item.id),
          updater: (parentItem) => {
            const currentNbColumns = item.children.length;
            const splitWidth =
              parseInt(item.attributes.width, 10) / currentNbColumns;

            parentItem.children.forEach((column) =>
              set(
                column,
                'attributes.width',
                `${parseInt(column.attributes.width, 10) + splitWidth}%`,
              ),
            );

            return parentItem;
          },
        });
      }
    },
    [type, item],
  );

  const label = __('Delete');

  return (
    <Tooltip initialPosition={tooltipPlace} childrenElement={label}>
      <ToolbarButton
        iconType={CATEGORIES.REGULAR}
        iconName="trash-can"
        onClick={handleDeleteItem}
        ariaLabel={label}
      />
    </Tooltip>
  );
};

export default ToolbarDelete;
